const brandLogo = require(`assets/${process.env.REACT_APP_NAME}/branding-logos/BrandLogo.jsx`); // eslint-disable-line import/no-dynamic-require
const navbarLogo = require(`assets/${process.env.REACT_APP_NAME}/branding-logos/NavbarLogo.jsx`); // eslint-disable-line import/no-dynamic-require
const siteIcon = require(`assets/${process.env.REACT_APP_NAME}/icons/SiteIcon.jsx`); // eslint-disable-line import/no-dynamic-require
const welcomeFlagIcon = require(`assets/${process.env.REACT_APP_NAME}/icons/welcome-flag-icon.svg`); // eslint-disable-line import/no-dynamic-require

export const BrandLogo = brandLogo.default;
export const NavbarLogo = navbarLogo.default;
export const SiteIcon = siteIcon.default;
export const WelcomeFlagIcon = welcomeFlagIcon.default;
